export default __webpack_public_path__ + "static/media/gallery_11.cb5f6acf.jpg";